import React, { Fragment } from 'react';

function MediaIntroPara() {
  return (
    <Fragment>
      As we build out the xMacroscope platform we will post images and videos here to
      demonstrate how the experience is working at each installation.
    </Fragment>
  );
}

export default MediaIntroPara;
